// src/api/timesheets.js

import {get, post, patch, postFormData} from "@/lib/fetcher"

/**
 * Fetch a single timesheet from the API by job slug
 */

export async function getCandidatePersonalData(){
    return await get ('/candidates/candidate')
}

export async function getCandidateCv(){
    return await get ('/candidates/candidate/cv')
}

export async function patchCandidatePersonalData(data){
    return await patch('/candidates/', 'candidate', data)
}
